'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _hexToRGBA = require('../../utils/hexToRGBA');

var _hexToRGBA2 = _interopRequireDefault(_hexToRGBA);

var _Vector = require('../../utils/Vector2');

var _Vector2 = _interopRequireDefault(_Vector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEG_TO_RAD = Math.PI / 180;

var Confetti = function () {
  function Confetti(bounds, offset, gravity, colors, fadeThreshold) {
    var size = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 5.0;

    _classCallCheck(this, Confetti);

    this.pos = new _Vector2.default(Math.random() * bounds.x, Math.random() * bounds.y - offset * bounds.y);
    this.rotationSpeed = Math.random() * 600 + 800;
    this.angle = DEG_TO_RAD * Math.random() * 360;
    this.rotation = DEG_TO_RAD * Math.random() * 360;
    this.cosA = 1.0;
    this.size = size;
    this.oscillationSpeed = Math.random() * 1.5 + 0.5;
    this.xSpeed = 40.0;
    this.ySpeed = Math.random() * gravity * 60 + 50.0;
    this.time = Math.random();
    this.bounds = bounds;

    var _colors = _slicedToArray(colors, 2);

    this.frontColor = _colors[0];
    this.backColor = _colors[1];

    this.fadeThreshold = fadeThreshold;

    this.corners = [];
    for (var i = 0; i < 4; i += 1) {
      var x = Math.cos(this.angle + DEG_TO_RAD * (i * 90 + 45));
      var y = Math.sin(this.angle + DEG_TO_RAD * (i * 90 + 45));
      var corner = new _Vector2.default(x, y);
      this.corners.push(corner);
    }
  }

  _createClass(Confetti, [{
    key: 'resetBounds',
    value: function resetBounds(bounds) {
      this.bounds = bounds;
    }
  }, {
    key: 'render',
    value: function render(duration, context, isLooping, removeParticle) {
      var _this = this;

      this.time += duration;
      this.rotation += this.rotationSpeed * duration;
      this.cosA = Math.cos(DEG_TO_RAD * this.rotation);

      this.pos.x += Math.cos(this.time * this.oscillationSpeed) * this.xSpeed * duration;
      this.pos.y += this.ySpeed * duration;

      if (this.pos.y > this.bounds.y) {
        if (removeParticle && !isLooping) {
          return false;
        }

        this.pos.x = Math.random() * this.bounds.x;
        this.pos.y = 0;

        if (!removeParticle && !isLooping) {
          this.display = false;
        }
      }

      if (!removeParticle && this.pos.y === 0 && isLooping) {
        this.display = true;
      }

      var startPosition = {
        x: (this.pos.x + this.corners[0].x * this.size) * window.devicePixelRatio,
        y: (this.pos.y + this.corners[0].y * this.size * this.cosA) * window.devicePixelRatio
      };

      function calculateOpacity(fadeThreshold, yPos, yMax) {
        switch (true) {
          case fadeThreshold === 1:
          case yPos / yMax < fadeThreshold:
            return 1;
          default:
            return 1 + fadeThreshold - yPos / yMax; // eslint-disable-line no-mixed-operators
        }
      }

      var opacity = calculateOpacity(this.fadeThreshold, this.pos.y, this.bounds.y);
      // eslint-disable-next-line no-param-reassign
      context.fillStyle = this.cosA > 0 ? (0, _hexToRGBA2.default)(this.frontColor, opacity) : (0, _hexToRGBA2.default)(this.backColor, opacity); // eslint-disable-line no-param-reassign
      context.beginPath();
      context.moveTo(startPosition.x, startPosition.y);

      this.corners.forEach(function (corner) {
        var endPosition = {
          x: (_this.pos.x + corner.x * _this.size) * window.devicePixelRatio,
          y: (_this.pos.y + corner.y * _this.size * _this.cosA) * window.devicePixelRatio
        };

        context.lineTo(endPosition.x, endPosition.y);
      });

      context.closePath();
      context.fill();

      return true;
    }
  }]);

  return Confetti;
}();

Confetti.displayName = 'Confetti';
exports.default = Confetti;